import {
    AvatarSize,
    AvatarType,
    BadgeColor,
    BadgeSize,
    ExAvatar,
    ExBadge,
    ExCard,
} from '@boomi/exosphere';
import { CheckCircle, Circle } from '@phosphor-icons/react';
import type { DataAttributes } from '../types/dataAttributes';
import styles from './HomeCard.module.css';

interface HomeCardProps extends DataAttributes {
    name: string;
    showCheck: boolean;
    iconSrc: string | undefined;
    subtext?: string;
    onSelect: () => void;
    kind?: 'config' | 'connector';
}

const HomeCard = ({
    name,
    showCheck,
    iconSrc,
    subtext,
    onSelect,
    kind = 'connector',
    ...dataAttributes
}: HomeCardProps) => {
    const isConfig = kind === 'config';
    return (
        <ExCard className={styles.card} onClick={onSelect} aria-label={name} {...dataAttributes}>
            <div className={styles.content}>
                <div className={styles.topRow}>
                    <div className={styles.iconWrap}>
                        {iconSrc ? (
                            <img src={iconSrc} alt={name} width={28} height={28} />
                        ) : (
                            <ExAvatar
                                size={AvatarSize.SMALL}
                                avatarType={AvatarType.USER}
                                firstName={name.split(' ')[0]}
                                lastName={name.split(' ')[1] ?? ''}
                            />
                        )}
                    </div>
                    {isConfig ? (
                        <ExBadge
                            color={showCheck ? BadgeColor.GREEN : BadgeColor.RED}
                            size={BadgeSize.EXTRASMALL}
                        >
                            {showCheck ? 'Enabled' : 'Disabled'}
                        </ExBadge>
                    ) : showCheck ? (
                        <CheckCircle className={styles.enabledDot} size={18} weight="bold" />
                    ) : (
                        <Circle className={styles.disabledDot} size={18} weight="bold" />
                    )}
                </div>
                <div className={isConfig ? styles.configName : styles.name}>{name}</div>
                {subtext && <div className={styles.idp}>{subtext}</div>}
            </div>
        </ExCard>
    );
};

export default HomeCard;
